/** Join class names, dropping anything falsy. Small enough not to warrant a dependency. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

/**
 * The one focus treatment in the product: a 2px green outline, offset 2px.
 * It is the same ring the global :focus-visible rule draws; components
 * carry it explicitly so a reset elsewhere cannot take it away.
 */
export const focusRing =
  'outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest';
